export enum enumErrorType {
  MESSAGE = 'message',
  TOAST = 'toast',
}